export default __webpack_public_path__ + "static/media/cart-shopping.03121472.svg";